import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { bonusesApi } from 'store/bonusesApi';
import { fetchSiteConfig } from 'store/siteSlice';
import { fetchLevels, fetchBonusMatrix } from 'store/levelSlice';
import { fetchUserWheelData } from 'store/userWheelSlice';

/**
 * Automatically invalidates and refetches all cached API responses and Redux slice states
 * whenever the active UI language changes (e.g. via language dropdown or URL route).
 */
export const useLanguageCacheInvalidation = () => {
  const dispatch = useAppDispatch();
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.slice(0, 2) || 'en';
  const prevLangRef = useRef(currentLang);

  useEffect(() => {
    // Only trigger when language actually changes, avoiding duplicate initial mount fetches
    if (prevLangRef.current !== currentLang) {
      prevLangRef.current = currentLang;

      // 1. Invalidate localized bonus tags so promotions/VIP descriptions refetch in the new language
      dispatch(bonusesApi.util.invalidateTags(['Bonus']));

      // 2. Refetch localized Redux slice state
      dispatch(fetchSiteConfig());
      dispatch(fetchLevels({ silent: true }));
      dispatch(fetchBonusMatrix({ silent: true }));
      if (isAuthenticated) {
        dispatch(fetchUserWheelData());
      }
    }
  }, [currentLang, dispatch, isAuthenticated]);
};
